import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LAYOUTS, SIZES } from './constants';

const ColorPalette = ({ colors, size = SIZES.medium, layout = LAYOUTS.oneRow }) => {
  const classes = classNames(
    'ws-ui-color-palette',
    `ws-ui-color-palette--${size}`,
    `ws-ui-color-palette--${layout}`
  );
  const isTwoRowLayout = layout === LAYOUTS.twoRow;

  const itemsPerRow = isTwoRowLayout ? Math.ceil(colors.length / 2) : colors.length;

  return (
    <div className={classes} style={{ '--items-per-row': itemsPerRow }}>
      {colors.map((color, idx) => (
        // eslint-disable-next-line yola/react/no-array-index-key
        <div className="ws-ui-color-palette__color" key={idx} style={{ backgroundColor: color }} />
      ))}
    </div>
  );
};

ColorPalette.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  size: PropTypes.oneOf(Object.values(SIZES)),
  layout: PropTypes.oneOf(Object.values(LAYOUTS)),
};

export default ColorPalette;
